module.exports = __webpack_public_path__ + "static/img/background.b9cb48fe.svg";